import { marked } from 'marked'

export function renderMarkdown(content, t, renderTitle = true) {
  if (!content) return null
  const renderer = new marked.Renderer()

  const options = {
    renderer,
    breaks: true,
    gfm: true,
    headerIds: false,
    mangle: false,
  }

  const consultationRecordText = t
    ? t('markdownRenderer.consultationRecord')
    : 'Registro da Consulta'
  return marked.parse(content, options)
}
